"use client";

import { useEffect } from "react";
import { capture } from "@/lib/analytics/events";

/**
 * Fires once when the board's empty state renders — i.e. a real search/filter
 * combination matched zero listings. Mount-only, no UI: this exists purely to
 * turn "Couldn't find what I wanted" exit-feedback (which names no specifics)
 * into a queryable `jobs_zero_results` series grouped by `query`/`filters`, so
 * a future run can tell a genuine content gap (the same ask recurring, always
 * zero) from a one-off apart from re-typing one quoted search by hand.
 */
export function JobsZeroResultsBeacon({
  query,
  filters,
}: {
  query: string;
  filters: string;
}) {
  useEffect(() => {
    capture("jobs_zero_results", { query, filters });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
